import { render, staticRenderFns } from "./TestTypeEdit.vue?vue&type=template&id=4143ac86&"
import script from "./TestTypeEdit.vue?vue&type=script&lang=js&"
export * from "./TestTypeEdit.vue?vue&type=script&lang=js&"
import style0 from "./TestTypeEdit.vue?vue&type=style&index=0&id=4143ac86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports